// Mirrors backend Reaction.Type choices (blorp/models/reactions.py) exactly.
// Order here drives both picker layout and count display order.
export const REACTIONS = [
  { type: "cheers", emoji: "🥂", label: "cheers" },
  { type: "like", emoji: "👍", label: "like" },
  { type: "love", emoji: "❤️", label: "love" },
  { type: "laugh", emoji: "😂", label: "laugh" },
  { type: "wow", emoji: "😮", label: "wow" },
  { type: "sad", emoji: "😢", label: "sad" },
  { type: "fire", emoji: "🔥", label: "fire" },
];
